/** «Личный кабинет» — ровно то, что отдаёт `GET /api/cabinet/report`. */
import { apiFetch, query } from "@/lib/api";

export type CabinetWindow = "pick" | "change" | "deal";
export type CabinetGroup = "day" | "week" | "month";

/** Счёт строки: человек (ссылка) считается в каждом поле один раз, `opens` — сумма открытий. */
export type CabinetCounts = {
  /** Зашли: открыли страницу хотя бы раз. */
  people: number;
  opens: number;
  /** Записались сами / перенесли запись. */
  booked: number;
  moved: number;
  /** Нажали кнопку мессенджера или бота на странице. */
  click_max: number;
  click_telegram: number;
  click_whatsapp: number;
  /** Запустили бота с хэшем ссылки. */
  bot_max: number;
  bot_telegram: number;
  push: number;
  push_denied: number;
  email: number;
};

export type CabinetRow = CabinetCounts & { day: string; to: string };

export type CabinetEvent = {
  /** Когда, MSK: `2026-10-03 01:32`. */
  at: string;
  window: CabinetWindow;
  kind: "open" | "book" | "move" | "click" | "bot" | "push" | "push_denied" | "email";
  channel: string | null;
  chat_id: number | null;
  deal_id: number | null;
  /** Ссылка выдана лиду (рассылка новым лидам): чата может не быть. */
  lead_id: number | null;
};

export type Cabinet = {
  from: string;
  to: string;
  group: CabinetGroup;
  total: CabinetCounts;
  windows: Record<CabinetWindow, { total: CabinetCounts; rows: CabinetRow[] }>;
  /** За всё время — по счётчикам ссылок. */
  alltime: {
    zapis: { issued: number; opened: number; opens: number; booked: number };
    deal: { issued: number; opened: number; opens: number };
  };
  /** Последние действия периода, свежие сверху. */
  feed: CabinetEvent[];
};

export function loadCabinet(from: string, to: string, group: CabinetGroup): Promise<Cabinet> {
  return apiFetch<Cabinet>(`/api/cabinet/report${query({ from, to, group })}`);
}
